<template>
  <div class="user">
    <div class="photo">
      <b-img v-if="avatar" :src="avatar" alt="avatar" />
      <img v-else src="/static/img/default-avatar.png" alt="user avatar"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           {{ nameAndSurname }}
           <b class="caret"></b>
        </span>
        <span class="loginTime">{{ $t('global.automaticLogout') }} {{ loginTime }}</span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <router-link to="/profile">
                <span class="sidebar-mini-icon">PR</span>
                <span class="sidebar-normal">{{ $t('buttons.profile') }}</span>
              </router-link>
            </li>
            <!--<li v-if="checkRoles('appConfiguration', 'AclConfiguration')">-->
              <!--<router-link to="/appconfiguration">-->
                <!--<span class="sidebar-mini-icon">CF</span>-->
                <!--<span class="sidebar-normal">{{ $t('buttons.appconfiguration') }}</span>-->
              <!--</router-link>-->
            <!--</li>-->
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">LO</span>
                <span class="sidebar-normal" @click="logout()">{{ $t('buttons.logout') }}</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>

import { CollapseTransition } from 'vue2-transitions'
import VueCookie from 'vue-cookie'
import { checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'

export default {
  components: {
    CollapseTransition
  },
  data () {
    return {
      // nameAndSurname: '',
      isClosed: true,
      avatar: null
    }
  },
  computed: {
    nameAndSurname () {
      return VueCookie.get('name') + ' ' + VueCookie.get('surname')
    },
    loginTime () {
      return this.$store.state.loginTime
    }
  },
  created () {
    this.getUserData()
    this.itemPusher = this.$store.state.Pusher.subscribe('user_datas-' + VueCookie.get('user_data_id'))
    this.itemPusher.bind('user_datas-' + VueCookie.get('user_data_id'), data => {
      this.getUserData()
    })
    // this.nameAndSurname = VueCookie.get('name') + ' ' + VueCookie.get('surname')
  },
  methods: {
    async getUserData () {
      if (VueCookie.get('user_data_id')) {
        const response = await new ApiService(`user_datas/${VueCookie.get('user_data_id')}`).getResults()
        if (response.avatarPreview) {
          this.avatar = response.avatarPreview
        }
      }
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    toggleMenu () {
      this.isClosed = !this.isClosed
    },
    logout () {
      VueCookie.delete('excm_accessToken')
      VueCookie.delete('excm_refreshToken')
      VueCookie.delete('expires_in')
      VueCookie.delete('name')
      VueCookie.delete('surname')
      VueCookie.delete('roles')
      VueCookie.delete('user_data_id')
      VueCookie.delete('user_id')
      VueCookie.delete('user_employer')
      VueCookie.delete('id_client_type')
      VueCookie.delete('default_route')
      VueCookie.delete('default_disable_roles_filtering')
      this.$router.push('/login')
    }
  }
}
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
